import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AuditRunnerPage } from '@/features/ndis-standards/audits/runner'
import { requireActiveSubscription } from '@/lib/middleware'

// `audits_.$auditId` (underscore suffix on `audits_`) is a NON-nested sibling
// of `audits.tsx` in TanStack file routing — its generated path is
// `/compliance/audits/$auditId`, not a child of the audits list page. Same
// escape hatch as `policies_.$policyId.tsx` (phase 2, Task 10).
const searchSchema = z.object({
  /** The question being answered. Absent means "resume at the first unanswered one". */
  q: z.string().optional(),
  view: z.literal('report').optional(),
  from: z.string().optional(),
  obligation: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/compliance/audits_/$auditId')({
  validateSearch: searchSchema,
  beforeLoad: async () => requireActiveSubscription(),
  component: AuditRunnerPage,
})